const breakpoints = {
  xs: "@media (max-width: 480px)",
  sm: "@media (max-width: 570px)",
  md: "@media (max-width: 768px)",
  lg: "@media (max-width: 1024px)",
  xl: "@media (max-width: 1220px)",
};

export default breakpoints;